// src/helpers/rutaRemitoDocumentos.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

const p = (path) => `/${String(path || "").replace(/^\/+/, "")}`;

const getToken = () => localStorage.getItem("token") || "";

const auth = () => {
  const token = getToken();
  return token ? { headers: { token } } : {};
};

const debug =
  String(process.env.REACT_APP_DEBUG_API || "").toLowerCase() === "true";

async function req(method, url, { params, data, signal } = {}) {
  try {
    if (debug) {
      console.log("👉 METHOD:", method);
      console.log("👉 URL:", API.getUri({ url, params }));
      if (data) console.log("📦 DATA:", data);
    }

    const res = await API.request({
      method,
      url,
      params,
      data,
      signal,
      ...auth(),
    });

    return res.data;
  } catch (err) {
    if (debug) {
      console.log("🧯 API ERROR:", err?.response?.data || err.message);
      console.log("🧯 STATUS:", err?.response?.status);
    }

    throw err;
  }
}

export async function getDocumentosRemito(id, { signal } = {}) {
  if (!id) throw new Error("Falta ID del remito.");

  return req("GET", p(`remitos/${id}/documentos`), {
    signal,
  });
}

export async function subirDocumentoRemito(id, tipo, file, { signal } = {}) {
  if (!id) throw new Error("Falta ID del remito.");
  if (!tipo) throw new Error("Falta tipo de documento.");
  if (!file) throw new Error("Falta archivo.");

  const formData = new FormData();
  formData.append("archivo", file);

  return req("POST", p(`remitos/${id}/documentos/${tipo}`), {
    data: formData,
    signal,
  });
}

export async function eliminarDocumentoRemito(id, tipo, { signal } = {}) {
  if (!id) throw new Error("Falta ID del remito.");
  if (!tipo) throw new Error("Falta tipo de documento.");

  return req("DELETE", p(`remitos/${id}/documentos/${tipo}`), {
    signal,
  });
}